<template>
  <v-container id="pdi-manager" fluid tag="section" class="dashboard-container" style="padding: 24px 96px;">
    <v-row class="mb-2 ma-n2" align="center">
      <v-col cols="12" sm="auto" class="pa-2">
        <div class="d-flex align-center">
          <v-icon color="#00E5FF" large class="mr-3">mdi-school</v-icon>
          <h1 class="text-h5 font-weight-bold text--primary">Gestão de PDIs</h1>
        </div>
      </v-col>
      <v-spacer />
      <v-col cols="12" sm="auto" class="pa-2">
        <v-btn v-if="activeTab === 0 && !isViewOnlyMode" color="#00E5FF" height="40" depressed class="px-5 font-weight-bold action-btn black--text" style="border-radius: 8px;" @click="openCreateDialog">
          <v-icon left color="black">mdi-plus</v-icon> Novo PDI
        </v-btn>
      </v-col>
    </v-row>
<!-- Abas -->
    <v-tabs 
      v-model="activeTab" 
      background-color="transparent" 
      color="#00E5FF" 
      slider-color="#00E5FF" 
      class="mb-4"
    >
      <v-tab 
        class="font-weight-bold text-none" 
        active-class="cyan--text text--accent-3"
      >
        <v-icon left small :color="activeTab === 0 ? '#00E5FF' : ''">mdi-account</v-icon>
        Meus PDIs
      </v-tab>
      <v-tab 
        class="font-weight-bold text-none" 
        active-class="cyan--text text--accent-3"
      >
        <v-icon left small :color="activeTab === 1 ? '#00E5FF' : ''">mdi-account-group</v-icon>
        PDI do Time
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="activeTab" style="background-color: transparent;">
      <v-tab-item>
        <v-row class="mb-2 ma-n2 top-cards-row">
          <v-col cols="12" md="6" class="pa-2 d-flex">
            <v-card class="elevment-card elevation-0 top-card flex-grow-1">
              <v-card-text class="pa-5 d-flex flex-column justify-center align-start" style="height: 100%">
                <v-icon large color="#00E5FF" class="mb-3">mdi-rocket-launch</v-icon>
                <div class="text-caption text--secondary mb-1">PDIs Ativos</div>
                <div class="text-h3 font-weight-bold" style="color: #00E5FF;">{{ myActivePdisCount }}</div>
                <div class="text-caption text--secondary mt-1">Aprovados + Em andamento</div>
              </v-card-text>
            </v-card>
          </v-col>

          <v-col cols="12" md="6" class="pa-2 d-flex">
            <v-card class="elevment-card elevation-0 top-card flex-grow-1">
              <v-card-text class="pa-5 d-flex flex-column justify-center align-start" style="height: 100%">
                <v-icon large color="success" class="mb-3">mdi-target-account</v-icon>
                <div class="text-caption text--secondary mb-1">Metas Concluídas</div>
                <div class="text-h3 font-weight-bold success--text">{{ myCompletedGoalsCount }}/{{ myTotalGoalsCount }}</div>
                <div class="text-caption text--secondary mt-1">{{ myGoalsCompletionPercentage }}% do total</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row align="center" class="ma-n2 mb-4 mt-2">
          <v-col cols="auto" class="pa-2">
            <v-chip-group v-model="myPdiFilter" mandatory>
              <v-chip value="all" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'all'}">Todos</v-chip>
              <v-chip value="draft" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'draft'}">Rascunhos</v-chip>
              <v-chip value="pending_approval" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'pending_approval'}">Em Aprovação</v-chip>
              <v-chip value="approved" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'approved'}">Aprovados</v-chip>
              <v-chip value="in_progress" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'in_progress'}">Em Progresso</v-chip>
              <v-chip value="completed" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'completed'}">Concluídos</v-chip>
              <v-chip value="rejected" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': myPdiFilter === 'rejected'}">Rejeitados</v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-row class="ma-n2">
          <v-col cols="12" class="pa-2">
            <v-card
              v-for="pdi in filteredMyPdis"
              :key="pdi.id"
              class="elevment-card elevation-0 mb-3 meeting-list-card"
            >
              <v-card-text class="pa-4">
                <v-row align="center" class="ma-0">
                  <v-col cols="auto" class="pa-0 pr-4">
                    <v-avatar size="48" :color="getStatusColor(pdi.status) + '20'" class="elevation-0">
                      <v-icon :color="getStatusColor(pdi.status)">{{ getStatusIcon(pdi.status) }}</v-icon>
                    </v-avatar>
                  </v-col>

                  <v-col class="pa-0 pr-4">
                    <div class="mb-1 d-flex align-center">
                      <div class="text-subtitle-1 font-weight-bold text--primary mr-3" style="line-height: 1.2;">
                        {{ pdi.title }}
                      </div>
                    </div>

                    <div class="d-flex flex-wrap gap-1 mt-1 align-center">
                      <v-chip x-small outlined class="mr-2 mb-1 elevation-0 theme-chip-topic">
                        <v-icon x-small left>mdi-tag</v-icon> {{ pdi.category || 'Sem categoria' }}
                      </v-chip>
                      <span class="text-caption text--secondary mb-1">
                        <v-icon x-small color="grey">mdi-calendar</v-icon>
                        {{ formatDate(pdi.deadline) }}
                      </span>
                    </div>

                    <div class="mt-3" style="max-width: 300px;">
                      <div class="d-flex justify-space-between align-center mb-1">
                        <span class="text-caption text--secondary">Progresso</span>
                        <span class="text-caption font-weight-bold" :class="getProgressColor(pdi.progress) + '--text'">{{ pdi.progress || 0 }}%</span>
                      </div>
                      <v-progress-linear
                        :value="pdi.progress || 0"
                        :color="getProgressColor(pdi.progress)"
                        height="6"
                        rounded
                        background-color="rgba(128,128,128,0.1)"
                      />
                    </div>
                  </v-col>

                  <v-col cols="auto" class="text-right pa-0 pr-3" style="min-width: 140px;">
                    <v-chip outlined x-small class="elevation-0 mb-2" :class="getStatusChipClass(pdi.status)">
                      {{ getStatusLabel(pdi.status) }}
                    </v-chip>

                    <div class="mt-1">
                      <div class="text-subtitle-2 font-weight-bold" :class="pdi.status === 'COMPLETED' ? 'success--text' : 'text--primary'">
                        <v-icon x-small :color="pdi.status === 'COMPLETED' ? 'success' : '#00E5FF'" class="mr-1">mdi-fire</v-icon>
                        +{{ pdi.xpReward || 500 }} XP
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="auto" class="pa-0">
                    <v-btn icon small color="grey" class="expand-btn" @click="toggleExpandMyPdi(pdi.id)">
                      <v-icon>{{ expandedMyPdis.includes(pdi.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-expand-transition>
                <div v-show="expandedMyPdis.includes(pdi.id)">
                  <v-divider class="theme-divider" />
                  <v-card-text class="pa-5 expanded-area" :style="{ backgroundColor: $vuetify.theme.dark ? '#121212' : '#F5F5F7' }">
                    
                    <div class="mb-4">
                      <div class="d-flex align-center mb-2">
                        <v-icon color="#00E5FF" small class="mr-2">mdi-note-text-outline</v-icon>
                        <span class="text-subtitle-2 font-weight-bold text--primary">Descrição</span>
                      </div>
                      <div class="text-body-2 pl-7 text--secondary" style="line-height: 1.5;">
                        {{ pdi.description || 'Sem descrição disponível.' }}
                      </div>
                    </div>

                    <div class="mb-4">
                      <div class="d-flex align-center mb-2">
                        <v-icon color="#00E5FF" small class="mr-2">mdi-target</v-icon>
                        <span class="text-subtitle-2 font-weight-bold text--primary">Metas ({{ pdi.goals ? pdi.goals.length : 0 }})</span>
                      </div>
                      
                      <div class="pl-7">
                        <v-expansion-panels v-if="pdi.status === 'COMPLETED' || pdi.status === 'IN_PROGRESS'" flat class="elevment-panels">
                          <v-expansion-panel v-for="(goal, index) in pdi.goals" :key="index" class="mb-2 elevment-panel">
                            <v-expansion-panel-header>
                              <div class="d-flex align-center">
                                <v-icon :color="(goal.status === 'DONE' || goal.completed) ? 'success' : 'grey'" class="mr-3">
                                  {{ (goal.status === 'DONE' || goal.completed) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                </v-icon>
                                <div class="flex-grow-1">
                                  <div :class="(goal.status === 'DONE' || goal.completed) ? 'text-decoration-line-through text--secondary' : 'font-weight-medium text--primary'">
                                    {{ goal.title }}
                                  </div>
                                  <v-chip v-if="goal.status === 'DONE' || goal.completed" outlined x-small class="theme-badge success--text mt-1">
                                    <v-icon x-small left>mdi-check</v-icon> Concluída
                                  </v-chip>
                                  <v-chip v-else outlined x-small class="theme-badge grey--text mt-1">
                                    <v-icon x-small left>mdi-progress-clock</v-icon> Pendente
                                  </v-chip>
                                </div>
                              </div>
                            </v-expansion-panel-header>
                            
                            <v-expansion-panel-content>
                              <v-divider class="theme-divider mb-4 mt-2" />
                              
                              <div v-if="goal.description" class="mb-4">
                                <div class="text-caption text--secondary mb-1">Descrição:</div>
                                <p class="text-body-2 text--primary mb-0">{{ goal.description }}</p>
                              </div>

                              <div v-if="goal.comments" class="mb-4">
                                <div class="text-caption font-weight-bold text--primary mb-1">
                                  <v-icon small color="success" class="mr-1">mdi-file-document-check</v-icon> Evidência de Conclusão:
                                </div>
                                <v-card flat outlined class="elevment-box pa-3">
                                  <p class="text-body-2 mb-0 text--primary">{{ goal.comments }}</p>
                                </v-card>
                              </div>

                              <div v-if="goal.evidenceUrl">
                                <div class="text-caption font-weight-bold text--primary mb-2">
                                  <v-icon small color="#00E5FF" class="mr-1">mdi-paperclip</v-icon> Comprovante Anexado:
                                </div>
                                <v-btn small color="#00E5FF" outlined class="font-weight-bold action-btn-outlined" @click="viewEvidence(goal.evidenceUrl)">
                                  <v-icon small left>mdi-open-in-new</v-icon> Visualizar Arquivo
                                </v-btn>
                              </div>

                              <div v-if="(goal.status === 'DONE' || goal.completed) && goal.completedAt" class="mt-3">
                                <div class="text-caption text--secondary">
                                  <v-icon x-small color="grey" class="mr-1">mdi-calendar-check</v-icon>
                                  Concluída em: {{ formatDate(goal.completedAt) }}
                                </div>
                              </div>
                            </v-expansion-panel-content>
                          </v-expansion-panel>
                        </v-expansion-panels>

                        <v-list v-else dense class="transparent-bg pa-0">
                          <v-list-item v-for="(goal, index) in pdi.goals" :key="index" class="px-0 min-h-auto">
                            <v-list-item-icon class="mr-3 my-1">
                              <v-icon small :color="(goal.status === 'DONE' || goal.completed) ? 'success' : 'grey'">
                                {{ (goal.status === 'DONE' || goal.completed) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                              </v-icon>
                            </v-list-item-icon>
                            <v-list-item-content class="py-1">
                              <v-list-item-title class="text-body-2" :class="(goal.status === 'DONE' || goal.completed) ? 'text-decoration-line-through text--secondary' : 'text--primary'">
                                {{ goal.title }}
                              </v-list-item-title>
                            </v-list-item-content>
                          </v-list-item>
                        </v-list>
                      </div>
                    </div>

                    <v-alert v-if="pdi.status === 'REJECTED' && pdi.rejectionReason" type="error" outlined dense class="mb-4 elevment-alert">
                      <div class="text-subtitle-2 font-weight-bold mb-1">Motivo da Rejeição:</div>
                      <div class="text-body-2">{{ pdi.rejectionReason }}</div>
                    </v-alert>

                    <div class="d-flex justify-end mt-4 gap-2 flex-wrap">
                      <v-btn v-if="pdi.status === 'DRAFT'" color="primary" outlined small class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="submitForApproval(pdi)">
                        <v-icon small left>mdi-send</v-icon> Enviar para Aprovação
                      </v-btn>

                      <v-btn v-if="pdi.status === 'DRAFT' || pdi.status === 'PENDING_APPROVAL'" color="#00E5FF" outlined small class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="editPdi(pdi)">
                        <v-icon small left>mdi-pencil</v-icon> Editar
                      </v-btn>

                      <v-btn v-if="pdi.status === 'DRAFT' || pdi.status === 'PENDING_APPROVAL'" color="error" outlined small class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="deletePdi(pdi)">
                        <v-icon small left>mdi-delete</v-icon> Excluir
                      </v-btn>

                      <v-btn v-if="pdi.status === 'APPROVED'" color="info" outlined small class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="startPdi(pdi)">
                        <v-icon small left>mdi-play-circle</v-icon> Iniciar PDI
                      </v-btn>

                      <v-btn v-if="pdi.status === 'IN_PROGRESS'" color="#00E5FF" depressed small class="font-weight-bold black--text" style="border-radius: 6px;" :disabled="isViewOnlyMode || (pdi.progress >= 100 && !canSelfApprove)" @click="openGoalsDialog(pdi)">
                        <v-icon small left color="black">mdi-check-circle</v-icon> Marcar Metas
                      </v-btn>

                      <v-btn v-if="pdi.status === 'IN_PROGRESS' && pdi.progress >= 100 && canSelfApprove" color="success" depressed small class="font-weight-bold white--text" style="border-radius: 6px;" :disabled="isViewOnlyMode" @click="completePdi(pdi)">
                        <v-icon small left color="white">mdi-check-all</v-icon> Concluir PDI
                      </v-btn>

                      <v-chip v-if="pdi.status === 'IN_PROGRESS' && pdi.progress >= 100 && !canSelfApprove" outlined x-small class="theme-badge success--text mt-1 ml-2">
                        <v-icon x-small left>mdi-clock-outline</v-icon> Aguardando avaliação do gestor
                      </v-chip>

                      <v-chip v-if="pdi.status === 'PENDING_APPROVAL'" outlined x-small class="theme-badge warning--text mt-1 ml-2">
                        <v-icon x-small left>mdi-clock-alert</v-icon> Aguardando aprovação
                      </v-chip>
                    </div>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>

            <v-card v-if="myPdis.length === 0 && !loadingMyPdis" class="pa-10 text-center elevment-card elevation-0">
              <v-icon size="64" color="rgba(128,128,128,0.2)">mdi-clipboard-text-outline</v-icon>
              <h3 class="text-h6 text--primary mt-5">Nenhum PDI pessoal cadastrado</h3>
              <p class="text-body-2 text--secondary mb-5">Comece criando seu primeiro Plano de Desenvolvimento Individual</p>
              <v-btn v-if="!isViewOnlyMode" color="#00E5FF" depressed @click="openCreateDialog" class="font-weight-bold black--text">
                <v-icon left color="black">mdi-plus</v-icon> Criar Primeiro PDI
              </v-btn>
            </v-card>

            <v-card v-if="loadingMyPdis" class="pa-10 text-center elevment-card elevation-0">
              <v-progress-circular indeterminate color="#00E5FF" size="48" />
              <p class="mt-4 text--secondary">Carregando seus PDIs...</p>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row class="mb-2 ma-n2 top-cards-row">
          <v-col cols="12" md="3" class="pa-2 d-flex">
            <v-card class="elevment-card elevation-0 top-card flex-grow-1">
              <v-card-text class="text-center pa-5 d-flex flex-column justify-center align-center" style="height: 100%">
                <v-icon size="40" color="#00E5FF">mdi-account-group</v-icon>
                <div class="text-h4 font-weight-bold mt-2" style="color: #00E5FF;">{{ teamMembers.length }}</div>
                <div class="text-caption text--secondary">Liderados</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" class="pa-2 d-flex">
            <v-card class="elevment-card elevation-0 top-card flex-grow-1">
              <v-card-text class="text-center pa-5 d-flex flex-column justify-center align-center" style="height: 100%">
                <v-icon size="40" color="warning">mdi-file-document-edit</v-icon>
                <div class="text-h4 font-weight-bold warning--text mt-2">{{ teamStats.pendingApproval }}</div>
                <div class="text-caption text--secondary">Pendentes Aprovação</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" class="pa-2 d-flex">
            <v-card class="elevment-card elevation-0 top-card flex-grow-1">
              <v-card-text class="text-center pa-5 d-flex flex-column justify-center align-center" style="height: 100%">
                <v-icon size="40" color="info">mdi-progress-clock</v-icon>
                <div class="text-h4 font-weight-bold info--text mt-2">{{ teamStats.inProgress }}</div>
                <div class="text-caption text--secondary">Em Progresso</div>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col cols="12" md="3" class="pa-2 d-flex">
            <v-card class="elevment-card elevation-0 top-card flex-grow-1">
              <v-card-text class="text-center pa-5 d-flex flex-column justify-center align-center" style="height: 100%">
                <v-icon size="40" color="success">mdi-check-all</v-icon>
                <div class="text-h4 font-weight-bold success--text mt-2">{{ teamStats.completed }}</div>
                <div class="text-caption text--secondary">Concluídos</div>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row align="center" class="ma-n2 mb-4 mt-2">
          <v-col cols="12" md="auto" class="pa-2">
            <v-text-field
              v-model="teamMemberSearch"
              placeholder="Buscar por nome..."
              prepend-inner-icon="mdi-magnify"
              outlined
              dense
              hide-details
              clearable
              class="elevment-input"
              color="#00E5FF"
              style="min-width: 240px; max-width: 100%"
            />
          </v-col>
          <v-col cols="12" md="auto" class="pa-2">
            <v-chip-group v-model="teamPdiFilter" mandatory>
              <v-chip value="all" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': teamPdiFilter === 'all'}">Todos</v-chip>
              <v-chip value="pending_approval" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': teamPdiFilter === 'pending_approval'}">Em Aprovação</v-chip>
              <v-chip value="approved" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': teamPdiFilter === 'approved'}">Aprovados</v-chip>
              <v-chip value="in_progress" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': teamPdiFilter === 'in_progress'}">Em Progresso</v-chip>
              <v-chip value="completed" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': teamPdiFilter === 'completed'}">Concluídos</v-chip>
              <v-chip value="rejected" outlined class="theme-chip theme-chip-filter font-weight-bold" :class="{'active': teamPdiFilter === 'rejected'}">Rejeitados</v-chip>
            </v-chip-group>
          </v-col>
        </v-row>

        <v-row class="ma-n2">
          <v-col cols="12" class="pa-2">
            <v-card
              v-for="member in filteredTeamMembers"
              :key="member.id"
              class="elevment-card elevation-0 mb-3 meeting-list-card"
            >
              <v-card-text class="pa-4">
                <v-row align="center" class="ma-0" @click="toggleExpandMember(member.id)" style="cursor: pointer;">
                  <v-col cols="auto" class="pa-0 pr-4">
                    <v-avatar color="rgba(0, 229, 255, 0.1)" size="48">
                      <v-icon v-if="!member.avatar" color="#00E5FF">mdi-account</v-icon>
                      <img v-else :src="member.avatar" :alt="member.name">
                    </v-avatar>
                  </v-col>

                  <v-col class="pa-0 pr-4">
                    <h3 class="text-subtitle-1 font-weight-bold text--primary mb-1" style="line-height: 1.2;">
                      {{ member.name }}
                    </h3>
                    <div class="d-flex flex-wrap gap-1 align-center">
                      <v-chip x-small outlined class="mr-2 mb-1 elevation-0 theme-chip-topic">
                        <v-icon x-small left>mdi-briefcase</v-icon> {{ member.jobRoleName || 'Cargo não informado' }}
                      </v-chip>
                      <span class="text-caption text--secondary mb-1">
                        <v-icon x-small color="grey">mdi-email</v-icon> {{ member.email }}
                      </span>
                    </div>
                  </v-col>

                  <v-col cols="auto" class="text-center pa-0 pr-6">
                    <div class="d-flex gap-3">
                      <div class="text-center mr-4">
                        <div class="text-subtitle-1 font-weight-bold" style="color: #00E5FF;">{{ getMemberPdisCount(member.id) }}</div>
                        <div class="text-caption text--secondary" style="font-size: 10px;">PDIs</div>
                      </div>
                      <div class="text-center">
                        <div class="text-subtitle-1 font-weight-bold success--text">{{ getMemberCompletedPdis(member.id) }}</div>
                        <div class="text-caption text--secondary" style="font-size: 10px;">Concluídos</div>
                      </div>
                    </div>
                  </v-col>

                  <v-col cols="auto" class="pa-0">
                    <v-btn icon small color="grey" class="expand-btn">
                      <v-icon>{{ expandedMembers.includes(member.id) ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-text>

              <v-expand-transition>
                <div v-show="expandedMembers.includes(member.id)">
                  <v-divider class="theme-divider" />
                  <v-card-text class="pa-5 expanded-area" :style="{ backgroundColor: $vuetify.theme.dark ? '#121212' : '#F5F5F7' }">
                    
                    <div v-if="getMemberPdis(member.id).length === 0" class="text-center py-6">
                      <v-icon size="48" color="rgba(128,128,128,0.2)">mdi-clipboard-text-off-outline</v-icon>
                      <p class="text-body-2 text--secondary mt-2 mb-0">Este colaborador não possui PDIs no filtro atual.</p>
                    </div>

                    <v-row v-else>
                      <v-col v-for="pdi in getMemberPdis(member.id)" :key="pdi.id" cols="12" class="pb-2">
                        <v-card outlined class="elevment-box">
                          <v-card-text class="pa-4">
                            <div class="d-flex align-center justify-space-between mb-3">
                              <div class="d-flex align-center">
                                <v-avatar :color="getStatusColor(pdi.status) + '20'" size="36" class="mr-3">
                                  <v-icon :color="getStatusColor(pdi.status)" small>{{ getStatusIcon(pdi.status) }}</v-icon>
                                </v-avatar>
                                <div>
                                  <h4 class="text-subtitle-2 font-weight-bold text--primary">{{ pdi.title }}</h4>
                                  <div class="d-flex align-center mt-1">
                                    <v-chip outlined x-small class="theme-badge mr-2" :class="getStatusChipClass(pdi.status)">
                                      {{ getStatusLabel(pdi.status) }}
                                    </v-chip>
                                    <span class="text-caption text--secondary">
                                      <v-icon x-small color="grey">mdi-calendar</v-icon> {{ formatDate(pdi.deadline) }}
                                    </span>
                                  </div>
                                </div>
                              </div>
                              <div class="text-right">
                                <div class="text-caption text--secondary" style="font-size: 10px;">Progresso</div>
                                <div class="text-subtitle-2 font-weight-bold" :class="getProgressColor(pdi.progress) + '--text'">
                                  {{ pdi.progress || 0 }}%
                                </div>
                              </div>
                            </div>

                            <v-progress-linear :value="pdi.progress || 0" :color="getProgressColor(pdi.progress)" height="4" rounded background-color="rgba(128,128,128,0.1)" class="mb-3" />

                            <p class="text-caption text--secondary mb-3">{{ pdi.description || 'Sem descrição.' }}</p>

                            <div v-if="pdi.goals && pdi.goals.length > 0">
                              <div class="text-caption font-weight-bold text--primary mb-1">
                                Metas ({{ pdi.goals.filter(g => g.status === 'DONE' || g.completed).length }}/{{ pdi.goals.length }})
                              </div>
                              <v-list dense class="transparent-bg pa-0">
                                <v-list-item v-for="(goal, idx) in pdi.goals" :key="idx" class="px-0 min-h-auto">
                                  <v-list-item-icon class="mr-2 my-1">
                                    <v-icon x-small :color="(goal.status === 'DONE' || goal.completed) ? 'success' : 'grey'">
                                      {{ (goal.status === 'DONE' || goal.completed) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                                    </v-icon>
                                  </v-list-item-icon>
                                  <v-list-item-content class="py-1">
                                    <v-list-item-title class="text-caption" :class="(goal.status === 'DONE' || goal.completed) ? 'text-decoration-line-through text--secondary' : 'text--primary'">
                                      {{ goal.title }}
                                    </v-list-item-title>
                                  </v-list-item-content>
                                </v-list-item>
                              </v-list>
                            </div>

                            <div class="d-flex justify-end mt-3 gap-2">
                              <v-btn v-if="pdi.status === 'PENDING_APPROVAL'" color="success" outlined small class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="approvePdi(pdi, member)">
                                <v-icon small left>mdi-check</v-icon> Aprovar
                              </v-btn>
                              <v-btn v-if="pdi.status === 'PENDING_APPROVAL'" color="error" outlined small class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="rejectPdi(pdi, member)">
                                <v-icon small left>mdi-close</v-icon> Rejeitar
                              </v-btn>
                              <v-btn v-else color="#00E5FF" text small class="font-weight-bold px-2" @click="viewPdiDetails(pdi, member)">
                                <v-icon small left>mdi-eye</v-icon> Detalhes
                              </v-btn>
                            </div>
                          </v-card-text>
                        </v-card>
                      </v-col>
                    </v-row>
                  </v-card-text>
                </div>
              </v-expand-transition>
            </v-card>

            <v-card v-if="loadingTeamPdis" class="pa-10 text-center elevment-card elevation-0">
              <v-progress-circular indeterminate color="#00E5FF" size="48" />
              <p class="mt-4 text--secondary">Carregando PDIs da equipe...</p>
            </v-card>

            <v-card v-if="filteredTeamMembers.length === 0 && !loadingTeamPdis" class="pa-10 text-center elevment-card elevation-0">
              <v-icon size="64" color="rgba(128,128,128,0.2)">mdi-clipboard-text-off-outline</v-icon>
              <h3 class="text-h6 text--primary mt-5">Nenhum PDI encontrado</h3>
              <p class="text-body-2 text--secondary mb-0">
                {{ teamMemberSearch ? 'Nenhum liderado encontrado para "' + teamMemberSearch + '"' : 'Nenhum liderado possui PDIs com este status.' }}
              </p>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>
    </v-tabs-items>

    <v-dialog v-model="dialog" max-width="800px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-text class="pa-6">
          <v-form ref="form" v-model="validForm">
            <div class="text-subtitle-2 font-weight-bold text--primary mb-2">Título do PDI *</div>
            <v-text-field v-model="editedPdi.title" placeholder="Ex: Desenvolver habilidades..." :rules="[v => !!v || 'Obrigatório']" outlined dense class="elevment-input mb-4" color="#00E5FF" hide-details="auto" />

            <div class="text-subtitle-2 font-weight-bold text--primary mb-2">Descrição *</div>
            <v-textarea v-model="editedPdi.description" placeholder="Descreva os objetivos..." :rules="[v => !!v || 'Obrigatório']" outlined rows="3" class="elevment-input mb-4" color="#00E5FF" hide-details="auto" />

            <v-row>
              <v-col cols="12" md="6">
                <div class="text-subtitle-2 font-weight-bold text--primary mb-2">Data Final *</div>
                <v-text-field v-model="editedPdi.deadline" type="date" :min="minDate" :rules="[v => !!v || 'Obrigatório']" outlined dense class="elevment-input mb-4" color="#00E5FF" hide-details="auto" prepend-inner-icon="mdi-calendar" />
              </v-col>
              <v-col cols="12" md="6">
                <div class="text-subtitle-2 font-weight-bold text--primary mb-2">Categoria *</div>
                <v-select v-model="editedPdi.category" :items="categoryOptions" placeholder="Selecione..." :rules="[v => !!v || 'Obrigatório']" outlined dense class="elevment-input mb-4" color="#00E5FF" item-color="cyan" hide-details="auto" prepend-inner-icon="mdi-tag" />
              </v-col>
            </v-row>

            <v-divider class="theme-divider my-4" />

            <div class="d-flex justify-space-between align-center mb-3">
              <span class="text-subtitle-2 font-weight-bold text--primary">Metas *</span>
              <v-btn small color="#00E5FF" outlined class="font-weight-bold action-btn-outlined" @click="addGoal">
                <v-icon small left>mdi-plus</v-icon> Adicionar Meta
              </v-btn>
            </div>

            <v-list dense class="transparent-bg">
              <v-list-item v-for="(goal, index) in editedPdi.goals" :key="index" class="px-0 mb-2">
                <v-list-item-content>
                  <v-text-field v-model="goal.title" dense outlined hide-details placeholder="Ex: Concluir curso de gestão" class="elevment-input" color="#00E5FF" />
                </v-list-item-content>
                <v-list-item-action class="my-0 ml-2">
                  <v-btn icon small color="error" @click="removeGoal(index)">
                    <v-icon small>mdi-delete</v-icon>
                  </v-btn>
                </v-list-item-action>
              </v-list-item>
            </v-list>

            <v-card v-if="!editMode" flat outlined class="mt-6 pa-4 elevment-box">
              <v-radio-group v-model="submitAction" hide-details class="mt-0 custom-radio">
                <v-radio value="DRAFT" color="#00E5FF">
                  <template #label>
                    <div>
                      <div class="font-weight-medium text--primary">Salvar como Rascunho</div>
                      <div class="text-caption text--secondary">Você poderá editar depois</div>
                    </div>
                  </template>
                </v-radio>
                <v-radio value="PENDING_APPROVAL" color="#00E5FF" class="mt-2">
                  <template #label>
                    <div>
                      <div class="font-weight-medium text--primary">Enviar para Aprovação</div>
                      <div class="text-caption text--secondary">Será enviado para análise do gestor</div>
                    </div>
                  </template>
                </v-radio>
              </v-radio-group>
            </v-card>
          </v-form>
        </v-card-text>

        <v-divider class="theme-divider" />
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn text height="40" class="px-5 font-weight-bold text--secondary" style="border-radius: 8px;" @click="closeDialog">Cancelar</v-btn>
          <v-btn :color="editMode ? 'success' : (submitAction === 'PENDING_APPROVAL' ? '#00E5FF' : 'grey')" height="40" depressed class="px-6 font-weight-bold" :class="submitAction === 'PENDING_APPROVAL' || !editMode ? 'black--text' : 'white--text'" style="border-radius: 8px;" :loading="saving" :disabled="editedPdi.goals.length === 0" @click="savePdi">
            <v-icon left :color="submitAction === 'PENDING_APPROVAL' || !editMode ? 'black' : 'white'">{{ editMode ? 'mdi-content-save' : (submitAction === 'PENDING_APPROVAL' ? 'mdi-send' : 'mdi-content-save') }}</v-icon>
            {{ editMode ? 'Atualizar' : (submitAction === 'PENDING_APPROVAL' ? 'Enviar' : 'Salvar') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="goalsDialog" max-width="800px" scrollable>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4 d-flex justify-space-between align-center">
          <h3 class="text-h5 font-weight-bold text--primary">Marcar Metas como Concluídas</h3>
          <v-btn icon color="grey" @click="closeGoalsDialog" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="theme-divider" />

        <v-card-text class="pa-6">
          <v-alert type="info" outlined dense class="elevment-alert mb-4 text-body-2">
            <strong>Fluxo:</strong> Expanda a meta, preencha a evidência de conclusão e depois marque como concluída.
          </v-alert>

          <v-expansion-panels v-model="expandedGoalPanels" multiple flat class="elevment-panels">
            <v-expansion-panel v-for="(goal, index) in selectedPdiGoals" :key="index" class="mb-2 elevment-panel">
              <v-expansion-panel-header>
                <div class="d-flex align-center">
                  <v-checkbox :input-value="goal.status === 'DONE'" @click.prevent.stop="isViewOnlyMode ? null : toggleGoalStatus(goal, index)" color="#00E5FF" :disabled="isViewOnlyMode" class="mt-0 pt-0" hide-details />
                  <v-chip v-if="!isViewOnlyMode && goal.needsEvidence" x-small outlined color="error" class="mt-1 ml-2 font-weight-bold">
                    <v-icon x-small left>mdi-alert</v-icon> Faltam evidências
                  </v-chip>
                  <div class="ml-3">
                    <div :class="goal.status === 'DONE' ? 'text-decoration-line-through text--secondary' : 'font-weight-medium text--primary'">
                      {{ goal.title }}
                    </div>
                    <v-chip v-if="goal.status === 'DONE'" outlined x-small class="theme-badge success--text mt-1">
                      <v-icon x-small left>mdi-check</v-icon> Concluída
                    </v-chip>
                  </div>
                </div>
              </v-expansion-panel-header>
              
              <v-expansion-panel-content>
                <v-divider class="theme-divider mb-4 mt-2" />
                
                <div v-if="goal.description" class="mb-4">
                  <div class="text-caption text--secondary mb-1">Descrição da Meta:</div>
                  <p class="text-body-2 text--primary mb-0">{{ goal.description }}</p>
                </div>

                <div class="text-caption font-weight-bold text--primary mb-2">Evidência de Conclusão *</div>
                <v-textarea :ref="'evidence-' + index" v-model="goal.comments" placeholder="Descreva os resultados..." outlined rows="3" class="elevment-input mb-3" color="#00E5FF"
                  :error="goal.needsEvidence || (goal.status === 'DONE' && (!goal.comments || goal.comments.trim().length < 10))"
                  :error-messages="goal.needsEvidence || (goal.status === 'DONE' && (!goal.comments || goal.comments.trim().length < 10)) ? 'Mínimo 10 caracteres' : ''"
                  @input="goal.needsEvidence = false"
                />

                <div class="elevment-box pa-4">
                  <div class="text-subtitle-2 text--primary mb-2">
                    <v-icon small left color="primary">mdi-paperclip</v-icon> Anexar Comprovante (opcional)
                  </div>
                  <v-btn outlined color="primary" class="font-weight-bold action-btn-outlined" :disabled="isViewOnlyMode" @click="selectFileForGoal(goal)" block small>
                    <v-icon left small>mdi-upload</v-icon> {{ goal.evidenceUrl ? 'Substituir Arquivo' : 'Selecionar Arquivo' }}
                  </v-btn>
                  
                  <div v-if="goal.evidenceUrl" class="mt-3 text-center">
                    <v-chip small outlined color="primary" class="theme-badge font-weight-bold" @click="viewEvidence(goal.evidenceUrl)" style="cursor: pointer;">
                      <v-icon small left>mdi-file-check</v-icon> Ver anexo salvo
                    </v-chip>
                  </div>
                </div>
              </v-expansion-panel-content>
            </v-expansion-panel>
          </v-expansion-panels>

          <v-divider class="theme-divider my-4" />

          <div class="d-flex align-center justify-space-between mb-2">
            <span class="text-subtitle-2 text--secondary">Progresso Global:</span>
            <span class="text-h6 font-weight-bold" :class="getProgressColor(calculateGoalsProgress()) + '--text'">{{ calculateGoalsProgress() }}%</span>
          </div>
          <v-progress-linear :value="calculateGoalsProgress()" :color="getProgressColor(calculateGoalsProgress())" height="8" rounded background-color="rgba(128,128,128,0.1)" />
        </v-card-text>

        <v-divider class="theme-divider" />
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn text height="40" class="px-5 font-weight-bold text--secondary" style="border-radius: 8px;" @click="closeGoalsDialog">Cancelar</v-btn>
          <v-btn color="#00E5FF" height="40" depressed class="px-6 font-weight-bold black--text" style="border-radius: 8px;" :loading="saving" :disabled="isViewOnlyMode || !validateGoalsEvidence()" @click="saveGoalsProgress">
            <v-icon left color="black">mdi-content-save</v-icon> Salvar Progresso
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="viewDetailsDialog" max-width="900px" scrollable>
      <v-card v-if="selectedPdi" class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4 d-flex justify-space-between align-start" :style="{ backgroundColor: 'var(--bg-card, #1A1A1A)' }">
          <div>
            <h3 class="text-h5 font-weight-bold text--primary">{{ selectedPdi.title }}</h3>
            <div class="text-caption text--secondary mt-1" v-if="selectedMember">
              <v-icon x-small color="grey">mdi-account</v-icon> {{ selectedMember.name }} - {{ selectedMember.email }}
            </div>
          </div>
          <v-btn icon color="grey" @click="viewDetailsDialog = false" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="theme-divider" />

        <v-card-text class="pa-6">
          <v-row class="mb-4">
            <v-col cols="12" md="6">
              <v-card flat outlined class="elevment-box text-center pa-4" style="height: 100%">
                <v-icon size="40" :color="getStatusColor(selectedPdi.status)">{{ getStatusIcon(selectedPdi.status) }}</v-icon>
                <div class="text-subtitle-1 font-weight-bold mt-2 text--primary">Status</div>
                <v-chip outlined small class="theme-badge mt-2" :class="getStatusChipClass(selectedPdi.status)">
                  {{ getStatusLabel(selectedPdi.status) }}
                </v-chip>
              </v-card>
            </v-col>
            <v-col cols="12" md="6">
              <v-card flat outlined class="elevment-box text-center pa-4" style="height: 100%">
                <v-icon size="40" :color="getProgressColor(selectedPdi.progress || 0)">mdi-chart-arc</v-icon>
                <div class="text-subtitle-1 font-weight-bold mt-2 text--primary">Progresso</div>
                <div class="text-h4 font-weight-bold mt-1" :class="getProgressColor(selectedPdi.progress || 0) + '--text'">
                  {{ selectedPdi.progress || 0 }}%
                </div>
                <v-progress-linear :value="selectedPdi.progress || 0" :color="getProgressColor(selectedPdi.progress || 0)" height="6" rounded background-color="rgba(128,128,128,0.1)" class="mt-2 mx-auto" style="max-width: 80%" />
              </v-card>
            </v-col>
          </v-row>

          <v-card flat outlined class="elevment-box mb-4 pa-4">
            <div class="text-subtitle-2 font-weight-bold text--primary mb-3">
              <v-icon color="#00E5FF" small class="mr-2">mdi-information</v-icon> Informações Gerais
            </div>
            <div class="text-caption text--secondary mb-1">Descrição:</div>
            <p class="text-body-2 text--primary mb-4">{{ selectedPdi.description || 'Sem descrição.' }}</p>

            <v-row>
              <v-col cols="12" md="6">
                <div class="text-caption text--secondary"><v-icon x-small color="grey">mdi-calendar-start</v-icon> Data de Criação:</div>
                <div class="text-body-2 text--primary font-weight-medium">{{ formatDate(selectedPdi.createdAt) || 'Não informado' }}</div>
              </v-col>
              <v-col cols="12" md="6">
                <div class="text-caption text--secondary"><v-icon x-small color="grey">mdi-calendar-end</v-icon> Prazo Final:</div>
                <div class="text-body-2 text--primary font-weight-medium">{{ formatDate(selectedPdi.deadline) }}</div>
              </v-col>
            </v-row>
          </v-card>

          <v-card flat outlined class="elevment-box pa-4">
            <div class="text-subtitle-2 font-weight-bold text--primary mb-3">
              <v-icon color="#00E5FF" small class="mr-2">mdi-target</v-icon> Metas
            </div>
            
            <div v-if="!selectedPdi.goals || selectedPdi.goals.length === 0" class="text-center py-4">
              <p class="text-body-2 text--secondary mb-0">Nenhuma meta cadastrada</p>
            </div>

            <v-expansion-panels v-else flat class="elevment-panels">
              <v-expansion-panel v-for="(goal, index) in selectedPdi.goals" :key="index" class="mb-2 elevment-panel">
                <v-expansion-panel-header>
                  <div class="d-flex align-center">
                    <v-icon :color="(goal.status === 'DONE' || goal.completed) ? 'success' : 'grey'" class="mr-3">
                      {{ (goal.status === 'DONE' || goal.completed) ? 'mdi-check-circle' : 'mdi-circle-outline' }}
                    </v-icon>
                    <div class="flex-grow-1">
                      <div :class="(goal.status === 'DONE' || goal.completed) ? 'text-decoration-line-through text--secondary' : 'font-weight-medium text--primary'">
                        {{ goal.title }}
                      </div>
                    </div>
                  </div>
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                  <v-divider class="theme-divider mb-3 mt-1" />
                  <div v-if="goal.description" class="mb-3">
                    <div class="text-caption text--secondary">Descrição:</div>
                    <p class="text-body-2 text--primary mb-0">{{ goal.description }}</p>
                  </div>
                  <div v-if="goal.comments" class="mb-3">
                    <div class="text-caption font-weight-bold text--primary">Evidência:</div>
                    <p class="text-body-2 text--secondary mb-0">{{ goal.comments }}</p>
                  </div>
                  <div v-if="goal.evidenceUrl">
                    <v-btn small color="#00E5FF" outlined class="font-weight-bold action-btn-outlined" @click="viewEvidence(goal.evidenceUrl)">
                      <v-icon small left>mdi-paperclip</v-icon> Visualizar Anexo
                    </v-btn>
                  </div>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-card>
        </v-card-text>

        <v-divider class="theme-divider" />
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn v-if="selectedPdi.status === 'IN_PROGRESS' && selectedPdi.progress >= 100" color="success" height="40" depressed class="px-6 font-weight-bold white--text mr-2" style="border-radius: 8px;" :disabled="isViewOnlyMode" @click="openCompleteTeamPdiDialog">
            <v-icon left color="white">mdi-check-all</v-icon> Concluir PDI do Liderado
          </v-btn>
          <v-btn text height="40" class="px-5 font-weight-bold text--secondary" style="border-radius: 8px;" @click="viewDetailsDialog = false">Fechar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="completePdiDialog" max-width="500px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4">
          <h3 class="text-h5 font-weight-bold" style="color: #00E5FF;"><v-icon left color="#00E5FF">mdi-check-all</v-icon> Concluir PDI</h3>
        </v-card-title>
        <v-divider class="theme-divider" />

        <v-card-text class="pa-6">
          <v-alert type="success" outlined dense class="elevment-alert mb-4">
            <strong>{{ selectedMember?.name }}</strong> concluiu todas as metas do PDI <strong>{{ selectedPdi?.title }}</strong>.
          </v-alert>

          <p class="text-body-2 text--secondary mb-3">Ao concluir este PDI, o colaborador receberá a recompensa de XP e o status será atualizado.</p>

          <div class="elevment-box pa-4 mb-4 d-flex align-center">
            <v-icon color="info" class="mr-3">mdi-trophy</v-icon>
            <div>
              <div class="text-subtitle-2 text--primary">Recompensa</div>
              <div class="font-weight-bold" style="color: #00E5FF;">+{{ selectedPdi?.xpReward || 500 }} XP</div>
            </div>
          </div>

          <div class="text-subtitle-2 font-weight-bold text--primary mb-2">Como deseja prosseguir?</div>
          <p class="text-caption text--secondary mb-0">Você pode concluir o PDI agora ou agendar uma reunião One-on-One para discutir os resultados com o colaborador.</p>
        </v-card-text>

        <v-divider class="theme-divider" />
        <v-card-actions class="pa-6 flex-wrap gap-2 justify-end">
          <v-btn text class="font-weight-bold text--secondary" @click="closeCompleteTeamPdiDialog" :disabled="saving">Cancelar</v-btn>
          <v-btn color="primary" outlined class="font-weight-bold action-btn-outlined" @click="completeTeamPdiOnly" :loading="saving">Apenas Concluir</v-btn>
          <v-btn color="#00E5FF" depressed class="font-weight-bold black--text" @click="completeTeamPdiAndSchedule" :disabled="saving">
            <v-icon left color="black">mdi-calendar-check</v-icon> Concluir e Agendar 1:1
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="scheduleDialog" max-width="600px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4 d-flex justify-space-between align-center">
          <h3 class="text-h5 font-weight-bold text--primary"><v-icon left color="#00E5FF">mdi-calendar-text</v-icon> Agendar One-on-One</h3>
          <v-btn icon color="grey" @click="closeScheduleDialog" small><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-divider class="theme-divider" />

        <v-card-text class="pa-6">
          <div class="elevment-box pa-4 mb-5">
            <div class="text-caption font-weight-bold text-uppercase mb-2" style="color: #00E5FF;">PDI Concluído</div>
            <div class="text-body-2 text--primary"><strong>Colaborador:</strong> {{ selectedMember?.name }}</div>
            <div class="text-body-2 text--primary"><strong>PDI:</strong> {{ selectedPdi?.title }}</div>
          </div>

          <v-form ref="scheduleForm" v-model="validScheduleForm">
            <v-row dense class="mb-4">
              <v-col cols="4">
                <div class="text-caption font-weight-bold text--primary mb-2">Data</div>
                <v-text-field v-model="newMeeting.date" type="date" :rules="[v => !!v || 'Obrigatório']" outlined dense class="elevment-input" color="#00E5FF" hide-details="auto" />
              </v-col>
              <v-col cols="4">
                <div class="text-caption font-weight-bold text--primary mb-2">Horário</div>
                <v-select v-model="newMeeting.time" :items="timeOptions" :rules="[v => !!v || 'Obrigatório']" outlined dense class="elevment-input" color="#00E5FF" hide-details="auto" />
              </v-col>
              <v-col cols="4">
                <div class="text-caption font-weight-bold text--primary mb-2">Duração</div>
                <v-select v-model="newMeeting.duration" :items="durationOptions" outlined dense class="elevment-input" color="#00E5FF" hide-details="auto" />
              </v-col>
            </v-row>

            <div class="text-caption font-weight-bold text--primary mb-2">Notas Prévias (opcional)</div>
            <v-textarea v-model="newMeeting.notes" placeholder="Adicione contexto para a reunião..." outlined rows="3" class="elevment-input" color="#00E5FF" hide-details="auto" />
          </v-form>
        </v-card-text>

        <v-divider class="theme-divider" />
        <v-card-actions class="pa-6">
          <v-spacer />
          <v-btn text height="40" class="px-5 font-weight-bold text--secondary" style="border-radius: 8px;" @click="closeScheduleDialog">Cancelar</v-btn>
          <v-btn color="#00E5FF" height="40" depressed class="px-6 font-weight-bold black--text" style="border-radius: 8px;" :loading="saving" :disabled="!validScheduleForm" @click="scheduleMeetingAndCompletePdi">
            <v-icon left color="black">mdi-calendar-check</v-icon> Agendar e Concluir
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="deleteDialog" max-width="500px">
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4">
          <h3 class="text-h5 font-weight-bold error--text"><v-icon left color="error">mdi-alert</v-icon> Confirmar Exclusão</h3>
        </v-card-title>
        <v-card-text class="pa-6 pt-0">
          <p class="text-body-1 text--primary">Tem certeza que deseja excluir o PDI <strong>"{{ pdiToDelete?.title }}"</strong>?</p>
          <p class="text-body-2 text--secondary mb-0">Esta ação não pode ser desfeita.</p>
        </v-card-text>
        <v-card-actions class="pa-6 pt-0">
          <v-spacer />
          <v-btn text class="font-weight-bold text--secondary" @click="cancelDelete">Cancelar</v-btn>
          <v-btn color="error" depressed class="font-weight-bold" @click="confirmDelete">Excluir</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-dialog v-model="lastGoalConfirmDialog" max-width="550px" persistent>
      <v-card class="elevment-dialog-card elevation-0">
        <v-card-title class="pa-6 pb-4">
          <h3 class="text-h5 font-weight-bold warning--text"><v-icon left color="warning">mdi-alert-circle</v-icon> Atenção - Última Meta</h3>
        </v-card-title>
        <v-card-text class="pa-6 pt-0">
          <p class="text-body-1 text--primary font-weight-bold">Você está prestes a marcar a última meta deste PDI!</p>
          <p class="text-body-2 text--secondary mb-4">Ao confirmar, o seguinte acontecerá:</p>
          
          <v-list dense class="transparent-bg mb-4">
            <v-list-item class="px-0 min-h-auto mb-2"><v-icon small color="success" class="mr-3">mdi-check-circle</v-icon><div class="text-body-2 text--primary">Seu PDI ficará com <strong>100% de progresso</strong></div></v-list-item>
            <v-list-item class="px-0 min-h-auto mb-2"><v-icon small color="#00E5FF" class="mr-3">mdi-send</v-icon><div class="text-body-2 text--primary">Seu PDI será <strong>enviado para avaliação</strong> do gestor</div></v-list-item>
            <v-list-item class="px-0 min-h-auto mb-2"><v-icon small color="warning" class="mr-3">mdi-lock</v-icon><div class="text-body-2 text--primary">Ficará <strong>bloqueado para edição</strong> até a aprovação</div></v-list-item>
          </v-list>
        </v-card-text>
        <v-card-actions class="pa-6 pt-0">
          <v-spacer />
          <v-btn text class="font-weight-bold text--secondary" @click="cancelLastGoalMark">Cancelar</v-btn>
          <v-btn color="success" depressed class="font-weight-bold" @click="confirmLastGoalMark">Confirmar e Marcar</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackbar" :color="snackbarColor" :timeout="3000" top elevation="0" rounded="lg">
      {{ snackbarText }}
      <template v-slot:action="{ attrs }">
        <v-btn text v-bind="attrs" @click="snackbar = false" color="white" class="font-weight-bold">Ok</v-btn>
      </template>
    </v-snackbar>

    <input ref="evidenceFileInput" type="file" accept="image/*,.pdf,.doc,.docx" style="display: none" @change="onEvidenceFileSelected">
  </v-container>
</template>

<script>
import { PdisService, ManagerService, FilesService, OneOnOnesService } from '@/services'

export default {
  name: 'PDIManager',

  data: () => ({
    activeTab: 0,
    
    // Meus PDIs
    loadingMyPdis: false,
    myPdis: [],
    expandedMyPdis: [],
    myPdiFilter: 'all', 
    
    // PDI do Time
    loadingTeamPdis: false,
    teamMembers: [],
    teamPdis: [],
    expandedMembers: [],
    teamPdiFilter: 'all', 
    teamMemberSearch: '', 
    teamStats: {
      pendingApproval: 0,
      inProgress: 0,
      completed: 0,
    },
    
    // Dialogs
    dialog: false,
    goalsDialog: false,
    viewDetailsDialog: false, 
    editMode: false,
    validForm: false,
    saving: false,
    submitAction: 'DRAFT',
    uploading: false, 
    currentUploadGoal: null, 
    
    selectedPdi: null,
    selectedMember: null, 
    selectedPdiGoals: [],
    expandedGoalPanels: [], 
    
    // Dialog Exclusão e Last Goal
    deleteDialog: false,
    pdiToDelete: null,
    lastGoalConfirmDialog: false,
    pendingGoalsSave: false,
    
    // Dialog Team Complete
    completePdiDialog: false,
    scheduleDialog: false,
    validScheduleForm: false,
    showSuggestions: true,
    customTopic: '',
    suggestedTopics: [
      'Avaliação do PDI concluído', 'Feedback sobre metas', 'Próximos objetivos'
    ],
    newMeeting: {
      meetingType: 'mentor', userId: null, date: '', time: '14:00', duration: 30,
      selectedTopics: [], customTopics: [], notes: '',
    },
    defaultMeeting: {
      meetingType: 'mentor', userId: null, date: '', time: '14:00', duration: 30,
      selectedTopics: [], customTopics: [], notes: '',
    },
    timeOptions: ['08:00', '08:30', '09:00', '09:30', '10:00', '10:30', '11:00', '11:30', '12:00', '13:00', '13:30', '14:00', '14:30', '15:00', '15:30', '16:00', '16:30', '17:00', '17:30', '18:00'],
    durationOptions: [
      { text: '15 min', value: 15 }, { text: '30 min', value: 30 },
      { text: '45 min', value: 45 }, { text: '60 min', value: 60 }, { text: '90 min', value: 90 },
    ],
    
    editedPdi: { title: '', description: '', deadline: '', category: '', status: 'DRAFT', goals: [] },
    defaultPdi: { title: '', description: '', deadline: '', category: '', status: 'DRAFT', goals: [] },
    
    categoryOptions: [
      'Liderança', 'Tecnologia', 'Comunicação', 'Gestão de Projetos',
      'Desenvolvimento Pessoal', 'Habilidades Técnicas', 'Soft Skills', 'Processos', 'Inovação',
    ],
    
    snackbar: false,
    snackbarText: '',
    snackbarColor: 'success',
  }),

  computed: {
    isViewOnlyMode() {
      try { return this.$store?.state?.viewOnlyMode === true } catch (error) { return false }
    },
    currentUser() {
      try {
        const userStr = localStorage.getItem('user')
        return userStr ? JSON.parse(userStr) : null
      } catch (error) { return null }
    },
    canSelfApprove() {
      if (!this.currentUser) return false
      return this.currentUser.role === 'MANAGER' && !this.currentUser.managerId
    },

    // Métricas Aba 1
    myActivePdisCount() {
      return this.myPdis.filter(pdi => pdi.status === 'APPROVED' || pdi.status === 'IN_PROGRESS').length
    },
    myTotalGoalsCount() {
      return this.myPdis.filter(pdi => pdi.status !== 'CANCELLED' && pdi.status !== 'REJECTED')
        .reduce((total, pdi) => total + (pdi.goals?.length || 0), 0)
    },
    myCompletedGoalsCount() {
      return this.myPdis.filter(pdi => pdi.status !== 'CANCELLED' && pdi.status !== 'REJECTED')
        .reduce((total, pdi) => {
          const completedInPdi = pdi.goals?.filter(goal => goal.status === 'DONE' || goal.completed === true).length || 0
          return total + completedInPdi
        }, 0)
    },
    myGoalsCompletionPercentage() {
      if (this.myTotalGoalsCount === 0) return 0
      return Math.round((this.myCompletedGoalsCount / this.myTotalGoalsCount) * 100)
    },
    filteredMyPdis() {
      if (this.myPdiFilter === 'all') return this.myPdis
      const statusMap = { 'draft': 'DRAFT', 'pending_approval': 'PENDING_APPROVAL', 'approved': 'APPROVED', 'in_progress': 'IN_PROGRESS', 'completed': 'COMPLETED', 'rejected': 'REJECTED' }
      return this.myPdis.filter(pdi => pdi.status === statusMap[this.myPdiFilter])
    },

    // Métricas Aba 2
    filteredTeamPdis() {
      const pdisWithoutDrafts = this.teamPdis.filter(pdi => pdi.status !== 'DRAFT')
      if (this.teamPdiFilter === 'all') return pdisWithoutDrafts
      const statusMap = { 'pending_approval': 'PENDING_APPROVAL', 'approved': 'APPROVED', 'in_progress': 'IN_PROGRESS', 'completed': 'COMPLETED', 'rejected': 'REJECTED' }
      return pdisWithoutDrafts.filter(pdi => pdi.status === statusMap[this.teamPdiFilter])
    },
    filteredTeamMembers() {
      const search = (this.teamMemberSearch || '').toLowerCase().trim()
      return this.teamMembers.filter(member => {
        const memberPdis = this.filteredTeamPdis.filter(pdi => pdi.userId === member.id)
        if (memberPdis.length === 0) return false
        if (!search) return true
        return (member.name || '').toLowerCase().includes(search) || (member.email || '').toLowerCase().includes(search)
      })
    },

    minDate() {
      return new Date().toISOString().split('T')[0]
    },
  },

  watch: {
    activeTab(newVal) {
      if (newVal === 0) this.loadMyPdis()
      else if (newVal === 1) this.loadTeamPdis()
    },
  },

  mounted() {
    this.loadMyPdis()
  },

  methods: {
    // ABA 1
    async loadMyPdis() {
      this.loadingMyPdis = true
      try {
        const response = await PdisService.list()
        const currentUserId = this.currentUser?.id
        this.myPdis = response.data.filter(pdi => pdi.userId === currentUserId)
      } catch (error) {
        this.showSnackbar('Erro ao carregar PDIs', 'error')
      } finally {
        this.loadingMyPdis = false
      }
    },

    toggleExpandMyPdi(pdiId) {
      const index = this.expandedMyPdis.indexOf(pdiId)
      if (index > -1) this.expandedMyPdis.splice(index, 1)
      else this.expandedMyPdis.push(pdiId)
    },

    openCreateDialog() {
      this.editMode = false
      this.editedPdi = { ...this.defaultPdi, goals: [], category: '' }
      this.submitAction = 'DRAFT'
      this.dialog = true
    },

    editPdi(pdi) {
      if (pdi.status !== 'DRAFT' && pdi.status !== 'PENDING_APPROVAL') {
        this.showSnackbar('Apenas PDIs em rascunho ou aprovação podem ser editados', 'warning')
        return
      }
      this.editMode = true
      this.editedPdi = { ...pdi, goals: pdi.goals ? pdi.goals.map(g => ({ ...g, status: g.status || 'PENDING' })) : [] }
      this.dialog = true
    },

    async deletePdi(pdi) {
      this.pdiToDelete = pdi
      this.deleteDialog = true
    },

    async confirmDelete() {
      if (!this.pdiToDelete) return
      try {
        this.loadingMyPdis = true
        this.deleteDialog = false
        await PdisService.delete(this.pdiToDelete.id)
        this.showSnackbar('PDI excluído!', 'success')
        await this.loadMyPdis()
      } catch (error) {
        this.showSnackbar('Erro ao excluir PDI', 'error')
      } finally {
        this.loadingMyPdis = false
        this.pdiToDelete = null
      }
    },

    cancelDelete() {
      this.deleteDialog = false
      this.pdiToDelete = null
    },

    closeDialog() {
      this.dialog = false
      this.$refs.form?.reset()
    },

    async savePdi() {
      if (!this.$refs.form.validate()) return
      if (this.editedPdi.goals.length === 0) {
        this.showSnackbar('Adicione pelo menos uma meta', 'warning')
        return
      }

      this.saving = true
      try {
        if (!this.editMode) {
          this.editedPdi.goals = this.editedPdi.goals.map(g => ({ ...g, status: 'PENDING' }))
          this.editedPdi.progress = 0
          this.editedPdi.status = this.submitAction
        } else {
          this.editedPdi.progress = this.calculatePdiProgress(this.editedPdi)
        }

        if (this.editMode) {
          await PdisService.update(this.editedPdi.id, { ...this.editedPdi, userId: this.currentUser?.id })
          this.showSnackbar('PDI atualizado!', 'success')
        } else {
          await PdisService.create(this.editedPdi)
          this.showSnackbar(this.submitAction === 'PENDING_APPROVAL' ? 'Enviado para aprovação!' : 'PDI criado!', 'success')
        }
        this.closeDialog()
        this.loadMyPdis()
      } catch (error) {
        this.showSnackbar('Erro ao salvar PDI', 'error')
      } finally {
        this.saving = false
      }
    },

    async submitForApproval(pdi) {
      try {
        await PdisService.updateStatus(pdi.id, 'PENDING_APPROVAL')
        this.showSnackbar('PDI enviado para aprovação!', 'success')
        this.loadMyPdis()
      } catch (error) {
        this.showSnackbar('Erro ao enviar PDI', 'error')
      }
    },

    async startPdi(pdi) {
      try {
        await PdisService.updateStatus(pdi.id, 'IN_PROGRESS')
        this.showSnackbar('PDI iniciado!', 'success')
        this.loadMyPdis()
      } catch (error) {
        this.showSnackbar('Erro ao iniciar', 'error')
      }
    },

    async completePdi(pdi) {
      try {
        await PdisService.updateStatus(pdi.id, 'COMPLETED')
        this.showSnackbar('PDI concluído!', 'success')
        this.loadMyPdis()
      } catch (error) {
        this.showSnackbar('Erro ao concluir', 'error')
      }
    },

    // Aba 2 - TIME
    async loadTeamPdis() {
      this.loadingTeamPdis = true
      try {
        const membersResponse = await ManagerService.getTeamMembers()
        this.teamMembers = membersResponse.data || []
        
        const pdisResponse = await ManagerService.getTeamPdis()
        this.teamPdis = pdisResponse.data || []
        
        this.calculateTeamStats()
      } catch (error) {
        this.showSnackbar('Erro ao carregar equipe', 'error')
      } finally {
        this.loadingTeamPdis = false
      }
    },

    calculateTeamStats() {
      this.teamStats.pendingApproval = this.teamPdis.filter(p => p.status === 'PENDING_APPROVAL').length
      this.teamStats.inProgress = this.teamPdis.filter(p => p.status === 'IN_PROGRESS').length
      this.teamStats.completed = this.teamPdis.filter(p => p.status === 'COMPLETED').length
    },

    toggleExpandMember(memberId) {
      const index = this.expandedMembers.indexOf(memberId)
      if (index > -1) this.expandedMembers.splice(index, 1)
      else this.expandedMembers.push(memberId)
    },

    getMemberPdis(memberId) { return this.filteredTeamPdis.filter(pdi => pdi.userId === memberId) },
    getMemberPdisCount(memberId) { return this.getMemberPdis(memberId).length },
    getMemberCompletedPdis(memberId) { return this.getMemberPdis(memberId).filter(p => p.status === 'COMPLETED').length },

    async approvePdi(pdi, member) {
      try {
        await PdisService.updateStatus(pdi.id, 'APPROVED')
        this.showSnackbar(`PDI aprovado!`, 'success')
        this.loadTeamPdis()
      } catch (error) {
        this.showSnackbar('Erro ao aprovar', 'error')
      }
    },

    async rejectPdi(pdi, member) {
      try {
        await PdisService.updateStatus(pdi.id, 'REJECTED')
        this.showSnackbar(`PDI rejeitado`, 'warning')
        this.loadTeamPdis()
      } catch (error) {
        this.showSnackbar('Erro ao rejeitar', 'error')
      }
    },

    viewPdiDetails(pdi, member) {
      this.selectedPdi = pdi
      this.selectedMember = member
      this.viewDetailsDialog = true
    },

    openCompleteTeamPdiDialog() { this.completePdiDialog = true },
    closeCompleteTeamPdiDialog() { this.completePdiDialog = false },

    async completeTeamPdiOnly() {
      if (!this.selectedPdi) return
      this.saving = true
      try {
        await PdisService.updateStatus(this.selectedPdi.id, 'COMPLETED')
        this.showSnackbar(`PDI concluído!`, 'success')
        this.closeCompleteTeamPdiDialog()
        this.viewDetailsDialog = false
        this.loadTeamPdis()
      } catch (error) {
        this.showSnackbar('Erro ao concluir', 'error')
      } finally {
        this.saving = false
      }
    },

    completeTeamPdiAndSchedule() {
      this.closeCompleteTeamPdiDialog()
      this.newMeeting = {
        ...this.defaultMeeting,
        selectedTopics: ['Avaliação do PDI concluído'],
        userId: this.selectedPdi?.userId,
        notes: `Avaliação do PDI: ${this.selectedPdi?.title}`,
      }
      const tomorrow = new Date()
      tomorrow.setDate(tomorrow.getDate() + 1)
      this.newMeeting.date = tomorrow.toISOString().split('T')[0]
      this.scheduleDialog = true
    },

    closeScheduleDialog() { this.scheduleDialog = false },

    async scheduleMeetingAndCompletePdi() {
      if (!this.$refs.scheduleForm.validate()) return
      this.saving = true
      try {
        await PdisService.updateStatus(this.selectedPdi.id, 'COMPLETED')
        
        const scheduledAt = `${this.newMeeting.date}T${this.newMeeting.time}:00`
        const meetingData = {
          meetingType: 'mentor', userId: this.selectedPdi.userId, scheduledAt, status: 'SCHEDULED',
          topics: [...this.newMeeting.selectedTopics, ...this.newMeeting.customTopics],
          notes: this.newMeeting.notes, duration: this.newMeeting.duration,
        }
        await OneOnOnesService.schedule(meetingData)
        this.showSnackbar(`PDI concluído e 1:1 agendada!`, 'success')
        
        this.closeScheduleDialog()
        this.viewDetailsDialog = false
        this.loadTeamPdis()
      } catch (error) {
        this.showSnackbar('Erro ao processar', 'error')
      } finally {
        this.saving = false
      }
    },

    // Métodos Genéricos Metas
    openGoalsDialog(pdi) {
      this.selectedPdi = { ...pdi }
      this.selectedPdiGoals = pdi.goals ? pdi.goals.map(g => ({ ...g, status: g.status || (g.completed ? 'DONE' : 'PENDING') })) : []
      this.goalsDialog = true
    },

    closeGoalsDialog() {
      this.goalsDialog = false
      this.selectedPdi = null
      this.selectedPdiGoals = []
      this.expandedGoalPanels = []
    },

    toggleGoalStatus(goal, index) {
      if (goal.status !== 'DONE' && (!goal.comments || goal.comments.trim().length < 10)) {
        this.$set(goal, 'needsEvidence', true)
        if (!this.expandedGoalPanels.includes(index)) this.expandedGoalPanels.push(index)
        this.$nextTick(() => {
          const field = this.$refs['evidence-' + index]
          if (field && field[0]) field[0].focus()
        })
        return
      }
      if (goal.needsEvidence) this.$set(goal, 'needsEvidence', false)
      goal.status = goal.status === 'DONE' ? 'PENDING' : 'DONE'
    },

    calculateGoalsProgress() {
      if (!this.selectedPdiGoals || this.selectedPdiGoals.length === 0) return 0
      const completed = this.selectedPdiGoals.filter(g => g.status === 'DONE').length
      return Math.round((completed / this.selectedPdiGoals.length) * 100)
    },

    validateGoalsEvidence() {
      return this.selectedPdiGoals.filter(g => g.status === 'DONE').every(g => g.comments && g.comments.trim().length >= 10)
    },

    confirmLastGoalMark() {
      this.lastGoalConfirmDialog = false
      this.pendingGoalsSave = true
      this.saveGoalsProgress()
    },

    cancelLastGoalMark() {
      this.lastGoalConfirmDialog = false
      this.pendingGoalsSave = false
    },

    async saveGoalsProgress() {
      if (!this.validateGoalsEvidence()) {
        this.showSnackbar('Preencha as evidências', 'warning')
        return
      }

      const progress = this.calculateGoalsProgress()
      const isMarkingLastGoal = progress === 100 && (this.selectedPdi.progress || 0) < 100

      if (isMarkingLastGoal && !this.pendingGoalsSave && !this.canSelfApprove) {
        this.lastGoalConfirmDialog = true
        return
      }

      this.saving = true
      try {
        const updatedPdi = { ...this.selectedPdi, goals: this.selectedPdiGoals, progress, status: 'IN_PROGRESS' }
        await PdisService.update(updatedPdi.id, updatedPdi)
        
        if (progress === 100 && !this.canSelfApprove && isMarkingLastGoal) {
          await this.scheduleOneOnOneForPdiCompletion(updatedPdi)
        }
        
        if (progress === 100) {
          this.showSnackbar(this.canSelfApprove ? 'Todas as metas concluídas!' : 'PDI finalizado. Gestor notificado.', 'success')
        } else {
          this.showSnackbar(`Progresso: ${progress}%`, 'success')
        }
        this.pendingGoalsSave = false
        this.closeGoalsDialog()
        this.loadMyPdis()
      } catch (error) {
        const errStr = error.response?.data || ''
        if (typeof errStr === 'string' && errStr.includes('10 caracteres')) {
          this.showSnackbar('Evidência insuficiente (mín. 10 char)', 'warning')
        } else {
          this.showSnackbar('Erro ao salvar', 'error')
        }
      } finally {
        this.saving = false
      }
    },

    async scheduleOneOnOneForPdiCompletion(pdi) {
      try {
        const date = new Date(); date.setDate(date.getDate() + 3);
        await OneOnOnesService.schedule({
          title: `${pdi.title} - Conclusão`,
          scheduledDate: date.toISOString().split('T')[0],
          notes: 'Avaliação de conclusão do PDI',
          status: 'SCHEDULED', userId: pdi.userId,
        })
      } catch (e) { console.error(e) }
    },

    addGoal() { this.editedPdi.goals.push({ title: '', status: 'PENDING', description: '' }) },
    removeGoal(index) { this.editedPdi.goals.splice(index, 1) },
    calculatePdiProgress(pdi) {
      if (!pdi.goals || pdi.goals.length === 0) return 0
      const completed = pdi.goals.filter(g => g.status === 'DONE' || g.completed).length
      return Math.round((completed / pdi.goals.length) * 100)
    },

    // Arquivos
    selectFileForGoal(goal) {
      this.currentUploadGoal = goal
      this.$refs.evidenceFileInput.click()
    },
    async onEvidenceFileSelected(event) {
      const file = event.target.files[0]
      if (!file || !this.currentUploadGoal) return
      if (file.size > 5 * 1024 * 1024) { this.showSnackbar('Máximo 5MB', 'warning'); event.target.value = ''; return }
      
      this.uploading = true
      this.showSnackbar('Enviando...', 'info')
      try {
        const response = await FilesService.upload(file, { context: 'pdi-evidence' })
        this.currentUploadGoal.evidenceUrl = response.data.url
        this.showSnackbar('Anexado!', 'success')
      } catch (e) {
        this.showSnackbar('Erro no upload', 'error')
      } finally {
        this.uploading = false; this.currentUploadGoal = null; event.target.value = ''
      }
    },
    viewEvidence(url) { window.open(url, '_blank') },

    // Utils
    getStatusColor(status) {
      const colors = { DRAFT: 'grey', PENDING_APPROVAL: 'orange', APPROVED: 'green', REJECTED: 'red', IN_PROGRESS: 'blue', COMPLETED: 'success', CANCELLED: 'grey' }
      return colors[status] || 'grey'
    },
    getStatusIcon(status) {
      const icons = { DRAFT: 'mdi-file-document-edit', PENDING_APPROVAL: 'mdi-clock-alert', APPROVED: 'mdi-check-circle', REJECTED: 'mdi-close-circle', IN_PROGRESS: 'mdi-progress-clock', COMPLETED: 'mdi-check-all', CANCELLED: 'mdi-cancel' }
      return icons[status] || 'mdi-file'
    },
    getStatusLabel(status) {
      const labels = { DRAFT: 'Rascunho', PENDING_APPROVAL: 'Em Aprovação', APPROVED: 'Aprovado', REJECTED: 'Rejeitado', IN_PROGRESS: 'Em Progresso', COMPLETED: 'Concluído', CANCELLED: 'Cancelado' }
      return labels[status] || status
    },
    getStatusChipClass(status) {
      const classes = { DRAFT: 'grey--text', PENDING_APPROVAL: 'orange--text', APPROVED: 'success--text', REJECTED: 'error--text', IN_PROGRESS: 'blue--text', COMPLETED: 'success--text', CANCELLED: 'grey--text' }
      return classes[status] || 'grey--text'
    },
    getProgressColor(progress) {
      if (progress >= 100) return 'success'
      if (progress >= 50) return 'blue'
      if (progress >= 1) return 'orange'
      return 'grey'
    },
    formatDate(date) { return date ? new Date(date).toLocaleDateString('pt-BR') : '-' },
    showSnackbar(text, color = 'success') { this.snackbarText = text; this.snackbarColor = color; this.snackbar = true },
  },
}
</script>

<style scoped>
/* Fundo Global Premium */
.dashboard-container {
  background-color: var(--bg-main, #0D0D0D) !important;
  max-width: 1440px;
  margin: 0 auto;
}

/* Base Cards */
.elevment-card {
  border-radius: 12px !important;
  border: 1px solid var(--border-color, rgba(128,128,128,0.15)) !important;
  background-color: var(--bg-card, #1A1A1A) !important;
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.meeting-list-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,0,0,0.1) !important;
}

/* Tags Delineadas / Pílulas Globais */
::v-deep .v-chip {
  border-radius: 9999px !important;
  background: transparent !important;
  border: 1px solid currentColor !important;
  text-transform: uppercase;
  font-weight: 700 !important;
  font-size: 10px !important;
}

/* Filtros */
.theme-chip-filter {
  border-color: var(--border-color, rgba(128,128,128,0.2)) !important;
  color: var(--text-secondary, #86868B) !important;
}
.theme-chip-filter.active {
  border-color: #00E5FF !important;
  color: #00E5FF !important;
  background-color: rgba(0, 229, 255, 0.05) !important;
}

/* Tópicos Normais (Não uppercase) */
::v-deep .theme-chip-topic {
  text-transform: none !important;
  font-weight: 500 !important;
  color: var(--text-secondary, #AEAEB2) !important;
  border-color: var(--border-color, rgba(128,128,128,0.2)) !important;
}

/* Componentes Base - Inputs, Dialogs e Divider */
.theme-divider {
  border-color: var(--border-color, rgba(128,128,128,0.15)) !important;
}

.elevment-dialog-card {
  border-radius: 12px !important;
  border: 1px solid var(--border-color, rgba(128,128,128,0.15)) !important;
  background-color: var(--bg-card, #1A1A1A) !important;
}

.elevment-box {
  background-color: var(--bg-secondary, rgba(128,128,128,0.05));
  border-radius: 8px;
  border: 1px solid var(--border-color, rgba(128,128,128,0.1));
}

.elevment-alert {
  border-radius: 8px !important;
  background-color: transparent !important;
}

/* Expansion Panels */
.transparent-bg { background-color: transparent !important; }
.min-h-auto { min-height: auto !important; }

::v-deep .elevment-panels .v-expansion-panel {
  background-color: transparent !important;
  border: 1px solid var(--border-color, rgba(128,128,128,0.15)) !important;
  border-radius: 8px !important;
}
::v-deep .elevment-panels .v-expansion-panel::before {
  box-shadow: none !important;
}

/* Radio Customizado (SaaS Style) */
::v-deep .custom-radio .v-radio {
  padding: 12px;
  border: 1px solid var(--border-color, rgba(128,128,128,0.15));
  border-radius: 8px;
  margin-bottom: 8px !important;
  transition: 0.2s ease;
}
::v-deep .custom-radio .v-radio.v-item--active {
  border-color: #00E5FF;
  background-color: rgba(0, 229, 255, 0.05);
}

.action-btn-outlined { letter-spacing: 0 !important; }
.expanded-area { border-radius: 0 0 12px 12px; }

/* Custom Scrollbar */
::-webkit-scrollbar { width: 6px; height: 6px; }
::-webkit-scrollbar-thumb { background: rgba(128, 128, 128, 0.3); border-radius: 3px; }
::-webkit-scrollbar-track { background: transparent; }
</style>
